<template>
  <div class="course-block block" v-if="data.course&&data.course.length>0" v-loadmore="loadMore">
    <div class="title">课程</div>
    <!-- 没开通会员 并且超过两节课 -->
    <template v-if="data.course.length>=2&&user&&!user.isvip">
      <div v-if="beforeAdvCourses">
        <card-course v-for="(item) in beforeAdvCourses" :key="item.id" :data="item"></card-course>
      </div>
      <router-link class="adv" tag="div" to="/vip/buy">
        2000+微课免费学，马上开通维修课程VIP会员
      </router-link>
      <div v-if="afterAdvCourses">
        <card-course v-for="(item) in afterAdvCourses" :key="item.id" :data="item"></card-course>
      </div>
    </template>
    <template v-else>
      <div>
        <card-course v-for="(item) in data.course" :key="item.id" :data="item"></card-course>
      </div>
    </template>
    <loading :more="more" :loaded="loaded"></loading>
  </div>
</template>

<script>
import CardCourse from '../card/card-course'
import {mapGetters} from 'vuex'
import {RES_OK} from '@/api/config'
import {getDefaultData} from '@/api/search'
import Loading from '../base/loading/loading2'
export default {
  components: {
    CardCourse,
    Loading
  },
  data() {
    return {
      data: {
        course: []
      },
      more: true,
      loaded: false,
      page: 1
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this._getDefaultData()
    },
    _getDefaultData() {
      getDefaultData(this.page).then(({data}) => {
        if (data.code === RES_OK && data.data) {
          this.data.course.push(...data.data.course)
          this.loaded = true
          this.page++
          // 加载完毕
          this.more = data.data.course.length >= 10
        }
      })
    },
    loadMore() {
      if (this.more && this.loaded) {
        this.loaded = false
        this._getDefaultData()
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    beforeAdvCourses() {
      // 第二个课程后显示vip广告
      return this.data.course && this.data.course.slice(0, 2)
    },
    afterAdvCourses() {
      // 第二个课程后显示vip广告
      return this.data.course && this.data.course.slice(2)
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .block{
    padding: 0 size(30)
    .title{
      fonts-size size(32)
      margin-bottom size(36)
      margin-top size(10)
    }
  }
  .course-block{
    .title{
      margin-bottom 0
    }
  }
  .adv{
    margin: 0 size(-30)
    height size(80)
    line-height size(80)
    text-align center
    color #fff
    font-size size(28)
    background-image url('~@/common/image/adv-bg.png')
    background-size 100% 100%
  }
</style>



// WEBPACK FOOTER //
// src/components/index/search-default.vue